import { createAction } from '@reduxjs/toolkit';

export const setIsBiometricGateEnabled = createAction(
    'NATIVE_CLIENT::SET_IS_BIOMETRIC_GATE_ENABLED',
);

export const authenticateFaceId = createAction(
    'NATIVE_CLIENT::AUTHENTICATE_FACE_ID',
);
export const authenticateFaceIdSuccess = createAction(
    'NATIVE_CLIENT::AUTHENTICATE_FACE_ID_SUCCESS',
);
export const authenticateFaceIdFail = createAction(
    'NATIVE_CLIENT::AUTHENTICATE_FACE_ID_FAIL',
);
